import useThemePreference, { useChatTextSize, useVibe } from "../../Hook/theme";
import { CHAT_TEXT_SIZES, THEME_PREFERENCES, VIBES } from "../../theme/mode";
import scale from "../../theme/scale.json";
import Segmented from "./Segmented";

/**
 * Light / Dark / System.
 *
 * Three values, because System is a standing instruction to follow the OS rather than
 * a third appearance, and a two-state toggle cannot say that. It is also the default.
 */
export function AppearanceSwitch({ className }: { className?: string }) {
  const [preference, setPreference] = useThemePreference();

  return (
    <Segmented
      testId="appearance-switch"
      className={className}
      value={preference}
      options={THEME_PREFERENCES}
      onPick={setPreference}
      label={(option) => `appearance__${option}`}
    />
  );
}

/** The softness axis. A handful of radii, and every corner in the product follows. */
export function VibeSwitch({ className }: { className?: string }) {
  const [vibe, setVibe] = useVibe();

  return (
    <Segmented
      testId="vibe-switch"
      className={className}
      value={vibe}
      options={VIBES}
      onPick={setVibe}
      label={(option) => scale.vibes[option].label}
    />
  );
}

/**
 * Standard / Large / Larger — only message text, pseudonyms, timestamps and quoted
 * lines follow it, so the layout never breaks at Larger.
 */
export function ChatTextSwitch({ className }: { className?: string }) {
  const [size, setSize] = useChatTextSize();

  return (
    <Segmented
      testId="chat-text-switch"
      className={className}
      value={size}
      options={CHAT_TEXT_SIZES}
      onPick={setSize}
      label={(option) => scale.chatText[option].label}
    />
  );
}

export default AppearanceSwitch;
